import { configRoutes } from "commons";

export const getPermissionUserPager = async (cod_TipoUsuario) => {
  const pathname = window.location.pathname;
  if (pathname === "/") {
    return true;
  } else {
    const [pagina, modulo] = pathname.split("/")[1].split("-");
    if (modulo !== undefined && pagina !== undefined) {
      if (configRoutes[modulo]) {
        const permissao = configRoutes[modulo][pagina].permissao;
        return permissao.includes(cod_TipoUsuario);
      }
    }
  }
};
